import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

export type CustomFieldScope = 'person' | 'company' | 'department' | 'team';
export type CustomFieldType =
  | 'text'
  | 'number'
  | 'date'
  | 'boolean'
  | 'single_select'
  | 'multi_select';

export type CustomFieldDefinition = {
  system: { id: string; company: string | number };
  details: {
    name: string;
    scope: CustomFieldScope;
    type: CustomFieldType;
    options?: string[];
    required?: boolean;
    active?: boolean;
    order?: number;
  };
  audit?: { date_created?: string; date_updated?: string };
};

export async function listCustomFields(params?: {
  scope?: CustomFieldScope;
  active?: boolean;
}) {
  const { data } = await axios.get(`${API_HOST}/v1/custom-fields`, { params });
  return data;
}

export async function createCustomField(payload: {
  name: string;
  scope: CustomFieldScope;
  type: CustomFieldType;
  options?: string[];
  required?: boolean;
  active?: boolean;
  order?: number;
}) {
  const { data } = await axios.post(`${API_HOST}/v1/custom-fields`, payload);
  return data;
}

export async function updateCustomField(
  id: string,
  payload: Partial<{
    name: string;
    type: CustomFieldType;
    options?: string[];
    required?: boolean;
    active?: boolean;
    order?: number;
  }>,
) {
  const { data } = await axios.patch(
    `${API_HOST}/v1/custom-fields/${id}`,
    payload,
  );
  return data;
}

